import React from "react";
import { fetchPanelApi, getContentLanguage } from "static-content/view/api";
import { AhpContainer, Option, Thumb, Legend, ButtonSend } from "./AhpSliderStyles";
import { DBOT_PANEL_BACKUP } from "../dbot-button/DbotButtonContainer";

export const AhpSlider = (props) => {
  const [widths, setWidths] = props.useState([50, 50]);
  const TagSliderRef = React.createRef();
  return (
    <>
      <AhpContainer ref={TagSliderRef}>
        {props.options.slice(0, 2).map((tag, index) => (
          <AhpOption
            width={widths[index]}
            key={index}
            index={index}
            label={tag.view.payload}
            onSliderSelect={(e) => onSlide(e, TagSliderRef, widths, setWidths)}
          />
        ))}
      </AhpContainer>
      {renderLegend(widths, props.options, props.onClickButton, setWidths)}
    </>
  );
};

const AhpOption = ({ label, width, onSliderSelect, index }) => {
  return (
    <Option width={width} className={index === 0 ? "left" : null}>
      {width > 10 && <span>{width > 38 ? label : [...label][0]}</span>}
      {index === 0 && <Thumb onPointerDown={onSliderSelect} />}
    </Option>
  );
};

export const getLanguage = () => {
  const active = getContentLanguage()
  return !!active ? active : 'ES'
}

const renderLegend = (widths, options, onClickButton, setWidths) => {
  const panelApi = fetchPanelApi("DBOT_PANEL", DBOT_PANEL_BACKUP);
  const ahpAnswer = {
    option1: options[0].view.payload,
    value1: widths[0],
    option2: options[1].view.payload,
    value2: widths[1],
  };
  const moreImportant = widths[0] > widths[1] ? 0 : 1;
  const saatyResult = getSaatyScale(widths[moreImportant]);
  const language = getLanguage()
  const result =
    widths[0] === widths[1]
      ? `${SAATY_LABELS[language][saatyResult].toLowerCase()}`
      : `${[...options[moreImportant].view.payload][0]} ${language === 'EN' ? 'is' : 'es'} ${SAATY_LABELS[language][saatyResult].toLowerCase()}`;
  return (
    <>
      <ButtonSend
        onClick={() =>
          onClickButton({
            ...options[moreImportant],
            textInput: result,
            ahp: ahpAnswer,
            extraValueLog: { code: "ahp", value: saatyResult },
          })
        }
      >{`${panelApi.get("INPUT_BUTTON")}: ${result}`}</ButtonSend>
      <Legend>
        <p style={{ textAlign: "center", cursor: "pointer" }}>
          <a
            onClick={(e) => {
              e.preventDefeult;
              setWidths([50, 50]);
            }}
          >
            Reset
          </a>
        </p>
      </Legend>
    </>
  );
};

const getPercentage = (containerWidth, distanceMoved) => (distanceMoved / containerWidth) * 100;
const nearestN = (N, number) => Math.ceil(number / N) * N;
const limitNumberWithinRange = (value, min, max) => Math.min(Math.max(value, min), max);

const onSlide = (e, TagSliderRef, widths, setWidths) => {
  const startDragX = e.pageX;
  const sliderWidth = TagSliderRef.current.offsetWidth;

  const resize = (e) => {
    const endDragX = e.touches ? e.touches[0].pageX : e.pageX;
    const percentageMoved = nearestN(1, getPercentage(sliderWidth, endDragX - startDragX));
    const newWidths = [
      limitNumberWithinRange(widths[0] + percentageMoved, 0, 100),
      limitNumberWithinRange(widths[1] - percentageMoved, 0, 100),
    ];
    setWidths(newWidths);
  };
  window.addEventListener("pointermove", resize);
  window.addEventListener("touchmove", resize);

  const removeEventListener = () => {
    window.removeEventListener("pointermove", resize);
    window.removeEventListener("touchmove", resize);
  };

  const handleEventUp = (e) => {
    removeEventListener();
  };

  window.addEventListener("touchend", handleEventUp);
  window.addEventListener("pointerup", handleEventUp);
};

const getSaatyScale = (value) => {
  switch (true) {
    case value === 50:
      return "equally_important";
    case value === 100:
      return "absolutely_more_important";
    case value > 80:
      return "very_much_more_important";
    case value > 60:
      return "much_more_important";
    case value > 50:
      return "somewhat_more_important";
    default:
      return "";
  }
};

const SAATY_LABELS = {
  ES: {
    equally_important: "Igualmente importantes",
    absolutely_more_important: "Muchísimo más importante",
    very_much_more_important: "Bastante más importante",
    much_more_important: "Más importante",
    somewhat_more_important: "Algo más importante",
  },
  EN: {
    equally_important: "Equally important",
    absolutely_more_important: "Absolutely more important",
    very_much_more_important: "Very much more important",
    much_more_important: "Much more important",
    somewhat_more_important: "Somewhat more important",
  },
};
